import type { ValueOf } from '../util/typeUtils';

export const CORPORATION_COMMANDS = {
    addDirector: 'addDirector',
    create: 'create',
    deactivate: 'deactivate',
    removeDirector: 'removeDirector',
    rename: 'rename',
} as const;

export type CORPORATION_COMMAND = ValueOf<typeof CORPORATION_COMMANDS>;
